/* eslint-disable import/prefer-default-export */

export const QUICK_SEARCH_SELECT = 'quicksearchselect';
export const QUICK_SEARCH_FETCH = 'quicksearchfetch';
export const QUICK_SEARCH_FETCH_COMPLETE = 'quicksearchfetchcomplete';
